import { render, staticRenderFns } from "./ManageTags.vue?vue&type=template&id=a41770ec&"
import script from "./ManageTags.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ManageTags.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports